import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-dispatch-driver-trips-modal',
  templateUrl: './dispatch-driver-trips-modal.component.html',
  styleUrls: ['./dispatch-driver-trips-modal.component.css']
})
export class DispatchDriverTripsModalComponent implements OnInit {
  @Input() driverId;
  @Output() close = new EventEmitter<any>();
  search;
  trips = [];
  preLevelOfServices = {};
  preCooperates = {};
  preSpaceTypes = {};
  constructor(
    private corporateService : CorporateService,
    private dispatchCenterService: DispatchCenterService
    ) { }

  ngOnInit() {
    this.getDriverTrips();
    this.getCorporate();
  }

  closeModal() {
    this.close.emit();
  }

  getDriverTrips() {
    this.dispatchCenterService.getDriverTrips(this.driverId).subscribe(data => {
      if (data) {
        this.trips = data.assigns;
      }
    })
  }




  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .subscribe(data => {
        if (data ) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

}
